<template>
  <div class="mpm_tooltip mpm-util-text-overflow-2">
    <a-tooltip>
      <template slot="title">{{ title || content }}</template>
      {{ content }}
    </a-tooltip>
  </div>
</template>

<script>
  export default {
    name: 'index',
    props: {
      title: String || Number,
      content: String || Number,
    },
    data() {
      return {}
    },
    created() {},
    methods: {},
  }
</script>

<style lang="scss" scoped>
  .mpm_tooltip {
  }
</style>
